import { sendGet } from "./axios";

export const getListSystem = () => sendGet("/cms/acms-page");